import React from 'react';
import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Home from "./screens";
import Layout from "./layout/Layout";
import Planning from "./screens/Planning/Planning";
import Questions from "./screens/Questions/Questions";
import {ThemeProvider} from "@mui/material";
import {setupTheme} from "./theme";
import HowToCome from "./screens/HowToCome";
import GuestAnswers from "./screens/GuestAnswers/GuestAnswers";
import Stay from "./screens/Stay/Stay";
import Visit from "./screens/Visit/Visit";
import WishList from "./screens/WishList";

const theme = setupTheme();

function App() {
  return (
      <ThemeProvider theme={theme}>
          <BrowserRouter>
              <Routes>
                  <Route path="/" element={<Layout ><Home /></Layout>}/>
                  <Route path="/planning" element={<Layout ><Planning /></Layout>}/>
                  <Route path="/howtocome" element={<Layout ><HowToCome/></Layout>}/>
                  <Route path="/questions" element={<Layout ><Questions /></Layout>}/>
                  <Route path="/rsvp" element={<Layout ><GuestAnswers /></Layout>}/>
                  <Route path="/stay" element={<Layout ><Stay /></Layout>}/>
                  <Route path="/visit" element={<Layout ><Visit /></Layout>}/>
                  <Route path="/wishlist" element={<Layout ><WishList /></Layout>}/>
              </Routes>
          </BrowserRouter>

      </ThemeProvider>
  );
}

export default App;
